
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link
} from "react-router-dom";
import BookingRecord from "../../screens/bookingRecord";
import BookingScreen from "../../screens/bookingScreen";
import ErrorScreen from "../../screens/errorScreen";
import Index from "../../screens/indexScreens";
import Login from "../../screens/login";
import Services from "../../screens/services";
import SignUP from "../../screens/signUp";
import UserScreen from "../../screens/userScreen";





function AppRouting(){

    return(
        <>
        <Router>
            <Routes>
                <Route path="/" element={<Index/>} />
                <Route path="/login" element={<Login/>} />
                <Route path="/signUp" element={<SignUP/>} />
                <Route path="/userScreen" element={<UserScreen/>} />
                <Route path="/bookingScreen" element={<BookingScreen/>} />
                <Route path="/bookingRecord" element={<BookingRecord/>} />
                <Route path="/services" element={<Services/>} />
                




                <Route path="*" element={<ErrorScreen/>} />
            </Routes>
        </Router>
        
        
        </>
    )
}

export default AppRouting;